import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/auth/actions';
import StepFourComponent from './components';

const mapStateToProps = state => {
  const { isloading, error, user, error_message } = state.auth;
  return {
    isloading,
    error,
    error_message,
    user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changePassword: (data, history) => {
      let chip_id = localStorage.getItem('chip_id');
      data.chip_id = chip_id;
      dispatch(Creators.changePassword(data, history));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepFourComponent);

